import { useLocation } from 'react-router-dom';
import { useChannels } from '@/hooks/queries';
import { useUi } from '@/store/ui';
import { ChatModal } from './ChatModal';
import { ChatIcon } from '@/components/ui/icons';

export function ChatFab() {
  const { pathname } = useLocation();
  const { data } = useChannels();
  const { chatOpen, chatChannelId, setChat } = useUi();

  if (pathname === '/chat' || pathname.startsWith('/chat/')) return null;

  /* Chat opened from a floor is that floor's chat, so the modal is told which
     one. Read from the path rather than carried in the store: the space you
     are on is where you are, not something a caller has to remember to say. */
  const spaceId = pathname.match(/^\/spaces\/([^/]+)/)?.[1];
  const isVirtualOffice = Boolean(spaceId);
  const unread = (data?.items ?? [])
    .filter((channel) => !spaceId || channel.spaceId === spaceId)
    .reduce((total, channel) => total + channel.unreadCount, 0);

  return (
    <>
      {!isVirtualOffice && (
        <button
          type="button"
          onClick={() => setChat(true)}
          aria-haspopup="dialog"
          aria-expanded={chatOpen}
          aria-label={unread > 0 ? `Open chat, ${unread} unread messages` : 'Open chat'}
          className="fixed bottom-[calc(1.25rem+env(safe-area-inset-bottom))] right-5 z-30 grid h-[52px] w-[52px] place-items-center rounded-full bg-brand-600 text-white shadow-[0_10px_30px_rgba(0,0,0,0.35)] transition-[background-color,transform,box-shadow] duration-150 hover:-translate-y-0.5 hover:bg-brand-500 hover:shadow-[0_14px_34px_rgba(0,0,0,0.42)] active:translate-y-0 sm:h-14 sm:w-14"
        >
          <ChatIcon size={24} />
          {unread > 0 && (
            <span className="badge-count absolute -right-1 -top-1 h-5 min-w-5 bg-red-500 leading-5 ring-2 ring-surface-0">
              {unread > 99 ? '99+' : unread}
            </span>
          )}
        </button>
      )}
      {chatOpen && (
        <ChatModal
          initialChannelId={chatChannelId}
          spaceId={spaceId}
          onClose={() => setChat(false)}
        />
      )}
    </>
  );
}
